/* eslint-disable no-console */
import {Col, Divider, Flex, Form, Radio, Row} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useEffect, useState} from 'react';

import {TF, monthsInFull} from '../../constants/Common';
import NumberInput from '../../shared/NumberInput';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import nestedArray from '../Forms/Utils/nestedArray';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

import {MYConfig, MYData} from './Interface/common';

const MonthlyYearlyDrawerForm: React.FC<{
  config: MYConfig[];
  data?: MYData[];
  disposalMethod?: {value: boolean; type: string; key: string};
  disabled?: boolean;
  nested?: string;
  timeFrameKey?: string;
}> = ({
  config,
  data = [],
  disabled = false,
  timeFrameKey = TF,
  nested = '',
  disposalMethod = {value: false, type: '', key: 'disposalMethod'}
}) => {
  const form = useFormInstance();

  const {setFieldValue} = form;
  const [isMonthly, setIsMonthly] = useState<string[]>(
    data.length > 0
      ? data.map((item) => {
          return item?.timeFrame;
        })
      : new Array(config.length).fill('monthly')
  );

  const [mainIndex, setMainIndex] = useState(0);
  const {financialYear} = useCompanyStore.getState().preUnits;

  const FYMonths = monthsInFull?.[financialYear];

  useEffect(() => {
    if (data?.length > 0) {
      setIsMonthly(
        data.map((item) => {
          return item?.timeFrame;
        })
      );
    }
  }, [data]);

  useEffect(() => {
    if (nested) {
      setMainIndex(nestedArray(nested).indexOf(disposalMethod.type));
    }
    config.forEach((item, index): void => {
      setFieldValue(
        nested ? [nested, mainIndex, TF, index, 'unit'] : [TF, index, 'unit'],
        config?.[index]?.unit
      );
    });
  }, [config]);

  return (
    <>
      {config.map((item, index) => {
    return (
      <React.Fragment key={index}>
        {config?.[index]?.dividerText && (
          <Divider orientation="left" orientationMargin="0" className="divider">
            {config?.[index].dividerText}
          </Divider>
        )}

        <Col
          className="gutter-row"
          span={24}
          style={{width: '100%', padding: '24px 0px'}}
        >
          <Flex
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: '20px'
            }}
          >
            <Flex style={{display: 'flex', justifyContent: 'space-between'}}>
              <Flex className="titleFlex">
                {/* <Flex
            vertical
            align="center"
            justify="center"
            style={{width: 'max-content', alignItems: 'flex-start'}}
          > */}
                <div className="quantity">
                  {item.mainTitle.title}
                  <span style={{color: '#99B1C7'}}>{`${
                    item.unit ? ` in ${item.unit}` : ''
                  } `}</span>
                  {item?.mainTitle?.tooltip && (
                    <InfoTooltip message={item?.mainTitle?.tooltip} />
                  )}
                </div>

                {/* </Flex> */}
              </Flex>
              <Flex>
                <Flex className="monthlyYearly">
                  {nested && (
                    <Form.Item
                      name={[nested, mainIndex]}
                      initialValue={{
                        [disposalMethod.key]: disposalMethod.type
                      }}
                      hidden
                    />
                  )}
                  <Form.Item
                    name={
                      nested
                        ? [nested, mainIndex, timeFrameKey, index]
                        : [timeFrameKey, index]
                    }
                    initialValue={{
                      type: config?.[index]?.mainTitle.key,
                      unit: config?.[index]?.unit
                    }}
                    hidden
                  />
                  <Form.Item
                    name={
                      nested
                        ? [nested, mainIndex, timeFrameKey, index, 'timeFrame']
                        : [timeFrameKey, index, 'timeFrame']
                    }
                    rules={[
                      {
                        transform: (value) => {
                          return value ? 'monthly' : 'yearly';
                        }
                      }
                    ]}
                    initialValue={isMonthly[index]}
                  >
                    <Radio.Group
                      buttonStyle="solid"
                      onChange={(e) => {
                        setIsMonthly((prev) => {
                          const clone = [...prev];
                          clone[index] = e.target.value;

                          return clone;
                        });
                      }}
                      disabled={disabled}
                      className="toggle"
                    >
                      <Radio.Button value={'monthly'}>Monthly</Radio.Button>
                      <Radio.Button value={'yearly'}>Yearly</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                </Flex>
              </Flex>
            </Flex>

            {isMonthly[index] === 'monthly' ? (
              <Row gutter={[8, 8]} style={{width: '100%'}}>
                {FYMonths?.map((month: string, MonthIndex: number) => {
                  return (
                    <Col key={MonthIndex} span={6}>
                      <Form.Item
                        name={
                          nested
                            ? [
                                nested,
                                mainIndex,
                                timeFrameKey,
                                index,
                                'data',
                                MonthIndex,
                                'value'
                              ]
                            : [timeFrameKey, index, 'data', MonthIndex, 'value']
                        }
                        className="formInput"
                        label={month}
                        key={MonthIndex}
                        colon={false}
                        initialValue={null}
                      >
                        <NumberInput
                          placeholder={month}
                          min={0}
                          disabled={disabled}
                          isMonYear={{isPercent: item.isPercent, value: true}}
                        />
                      </Form.Item>
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <Form.Item
                name={
                  nested
                    ? [
                        nested,
                        mainIndex,
                        timeFrameKey,
                        index,
                        'data',
                        0,
                        'value'
                      ]
                    : [timeFrameKey, index, 'data', 0, 'value']
                }
                className="formInput"
                label="Yearly"
                colon={false}
                initialValue={null}
              >
                <NumberInput
                  placeholder="Yearly"
                  disabled={disabled}
                  isMonYear={{isPercent: item.isPercent, value: true}}
                />
              </Form.Item>
            )}
          </Flex>
        </Col>
      </React.Fragment>
    );
  })}
    </>
  );
};

export default MonthlyYearlyDrawerForm;
